import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DeliberyNoteServices } from "../../services";
import { Globals } from "../../../../globals";
import { DeliberyNoteCreateIngprodPricePage } from "../delibery-note-create-ingprod-price/delibery-note-create-ingprod-price";
import { IngredientsServices } from "../../../ingredients/services";
import { ProductsServices } from "../../../products/services";
import { ProductCreateWfoodcostInfoPage } from "../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info";
import { IngredientCreateInfoPage } from "../../../ingredients/ingredient-create/ingredient-create-info/ingredient-create-info";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DeliberyNoteCreateSelectIngprodPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-create-select-ingprod',
  templateUrl: 'delibery-note-create-select-ingprod.html',
})
export class DeliberyNoteCreateSelectIngprodPage {

  update_state: boolean = false;
  //dish_uid: string;
  ingredient_uid: string;
  prodings: any;
  ingredient_measurement: any;
  ingredient_name: any;
  delibery_note_uid: any;
  provider_name: any;
  provider_uid: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public deliberyNoteServices: DeliberyNoteServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService) {

    this.deliberyNoteServices.list_array_tmp.length = 0;
    this.deliberyNoteServices.getListPartialSelect(this.globals.restaurant_uid);

    this.delibery_note_uid = this.navParams.get('delibery_note_uid');

    this.update_state = this.navParams.get('update_state');
    this.prodings = this.navParams.get('prodings');
    this.provider_name = this.navParams.get('provider_name');
    this.provider_uid = this.navParams.get('provider_uid');
  }

  async ionViewWillEnter() {
    this.deliberyNoteServices.getPagesIngredientsProducts(0);
    this.deliberyNoteServices.page_active = 1;

    if (this.update_state) {
      // Modo edición: cargar ingredientes existentes del albarán
      if (this.prodings != null) {
        if (Object.keys(this.prodings).length > 0) {

          this.deliberyNoteServices.prodings_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.
          for (let entry of this.prodings.list) {
            //Recuperamos los valores del providers a tratar

            //if type ing or prod
            if (entry.type == 'ingredient') {
              await this.ingredientsServices.firestore.collection('ingredients').doc(entry.uid_ingredient).get().then(doc => {
                var v = doc.data();
                var _array = Array();
                _array.push(entry.uid_ingredient);
                _array.push(v.name);
                _array.push(entry.type);
                _array.push(entry.price);
                _array.push(v.measurement);
                for (let key in v.providers) {
                  if (v.providers[key].default) {
                    _array.push(v.providers[key].tax_static);
                  }
                }
                _array.push(entry.quantity);
                _array.push(entry.discount);
                _array.push(entry.total);
                _array.push(entry.tax);
                _array.push(entry.uid_ingredient);
                _array.push(''); //lote
                this.deliberyNoteServices.prodings_array_tmp.push(_array);
              });
            } else {
              await this.productsServices.firestore.collection('products').doc(entry.uid_product).get().then(doc => {
                var v = doc.data();
                var _array = Array();
                _array.push(entry.uid_product);
                _array.push(this.globals.nameLangSelectProduct(v.name));
                _array.push(entry.type);
                _array.push(entry.price);
                _array.push(v.measurement);
                for (let key in v.providers) {
                  if (v.providers[key].default) {
                    _array.push(v.providers[key].tax_static);
                  }
                }
                _array.push(entry.quantity);
                _array.push(entry.discount);
                _array.push(entry.total);
                _array.push(entry.tax);
                _array.push(entry.uid_product);
                _array.push(entry.pvp);
                _array.push(0); //total_sin_iva
                _array.push(''); //lote
                this.deliberyNoteServices.prodings_array_tmp.push(_array);
              });
            }
          }
        }
      }
    } else {
      // Modo creación: limpiar array SIEMPRE que no tenga elementos previos válidos
      // o que estemos iniciando un nuevo flujo (no viniendo de la página de precios)
      const fromPricePage = this.navParams.get('from_price_page');
      
      // Si no venimos de la página de precios, limpiar
      // Esto previene acumulación de ingredientes en navegaciones múltiples
      if (!fromPricePage) {
        // IMPORTANTE: Limpiar siempre al iniciar nuevo flujo o navegar desde otras páginas
        // Solo preservar si ya hay elementos Y venimos de provider_order Y no es primera vez
        const isFirstEntry = this.deliberyNoteServices.prodings_array_tmp.length === 0;
        
        if (isFirstEntry || this.navParams.get('origin') !== 'provider_order') {
          this.prodings = Array();
          this.deliberyNoteServices.prodings_array_tmp = Array();
          console.log('Array de ingredientes limpiado al entrar en modo creación');
        }
      }
    }
    this.deliberyNoteServices.prodings_array_tmp = [...this.deliberyNoteServices.prodings_array_tmp];
  }

  openProdingQuantCost() {
    if (this.deliberyNoteServices.prodings_array_tmp.length > 0) {
      this.globals.GAtrackView('Stock', 'Stock - Delibery note - Select prodings - Create', this.globals.restaurant.email, 'Create/Update', 'Create  select prodings delibery note', 'Stock', '');

      if (this.navParams.get('origin') == 'provider_order') {
        this.navCtrl.push(DeliberyNoteCreateIngprodPricePage, {
          update_state: false,
          delibery_note_uid: this.delibery_note_uid,
          origin: 'provider_order',
          provider_name: this.provider_name,
          provider_uid: this.provider_uid,
        });
      } else {
        this.navCtrl.push(DeliberyNoteCreateIngprodPricePage, {
          update_state: this.update_state,
          delibery_note_uid: this.delibery_note_uid,
          provider_name: this.provider_name,
          provider_uid: this.provider_uid,
        });
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-ingrediente-producto'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  openCreateIngredient() {
    this.ingredientsServices.quick_create = true;
    this.ingredientsServices.quick_create_type = true;
    this.navCtrl.push(IngredientCreateInfoPage);
  }

  openCreateProduct() {
    this.productsServices.quick_create = true;
    this.productsServices.quick_create_type = true;
    this.navCtrl.push(ProductCreateWfoodcostInfoPage);
  }
  searchProductsIngredientsNode(value) {
    this.deliberyNoteServices.searchProductsIngredientsNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-select-ingprod.ts